import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { stripeInputStyles, stripeLabelStyles } from '../hub-utils';

interface PortalLoginEmailFieldProps {
  email: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  onFocus?: () => void;
  error?: string | null | false;
  inputStyle?: React.CSSProperties;
  testId?: string;
}

const PortalLoginEmailField: React.FC<PortalLoginEmailFieldProps> = ({
  email,
  onChange,
  onBlur,
  onFocus,
  error,
  inputStyle,
  testId = 'portal-login-email',
}) => {
  const defaultInputStyle: React.CSSProperties = {
    ...stripeInputStyles,
    ...(error ? { borderColor: '#df1b41' } : {}),
  };

  return (
    <Box>
      <Typography component="label" sx={stripeLabelStyles}>
        Portal Login Email
      </Typography>
      <input
        type="email"
        value={email}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder="email@example.com"
        style={inputStyle || defaultInputStyle}
        data-testid={testId}
      />
      {error && (
        <Typography sx={{ color: '#df1b41', fontSize: '12px', mt: 0.5 }}>
          {error}
        </Typography>
      )}
      {!error && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, color: '#0369a1' }}>
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          <Typography variant="caption" sx={{ color: '#0369a1' }}>
            A portal account will be created and a welcome email will be sent to this address
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PortalLoginEmailField;
